/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AppRouterDefinition from "./../../../AppRouterDefinition";

const PostausgangView = React.lazy(() => import(/* webpackChunkName: "EMails_EMails" */ "./../Views/PostausgangView"));
const PostausgangBreadcrumb = React.lazy(() => import(/* webpackChunkName: "EMails_EMails" */ "./../Components/PostausgangBreadcrumb"));

export const eMailsRouterDefinitions: Array<AppRouterDefinition> = [
    {
        path: "/postausgang",
        render: (renderProps: any) => <PostausgangView {...renderProps} />,
        createBreadcrumbs: () => [<PostausgangBreadcrumb />],
        exact: true,
    },
    {
        path: "/systemPostausgang",
        render: (renderProps: any) => <PostausgangView {...renderProps} />,
        createBreadcrumbs: () => [<PostausgangBreadcrumb />],
        exact: true,
    },
];
